export default __webpack_public_path__ + "static/media/expose4.2346c9f9.png";